import React, { createContext, useContext } from 'react';
import { FilterProps, TableData } from '../table/Table';

const FilterContext = createContext<IFilterContext | undefined>(undefined);

interface IFilterContext extends FilterProps<TableData> {
  getFilterValue: (columnId: string) => any;
}

export const FilterProvider: React.FC<FilterProps<TableData>> = ({ children, ...props }) => {
  const getFilterValue = (columnId: string) => {
    const filter = props.filters.find((e) => e.id === columnId);
    return filter ? filter.value : null;
  };

  return (
    <FilterContext.Provider value={{ getFilterValue, ...props }}>{children}</FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilterContext must be within FilterProvider');
  }
  return context;
};
